// import * as openpgp from "https://cdn.jsdelivr.net/npm/openpgp@5.0.0/dist/lightweight/openpgp.min.mjs";
import * as openpgp from 'openpgp/lightweight'

// default compression for file encryption
openpgp.config.preferredCompressionAlgorithm = openpgp.enums.compression.zip

let CryptoUtil = {
  generatePassword () {
    let CHARs = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz~!@-#$%^&*()_+-=`[]{};:\'",./<>?|\\'
    let length = 500 + Math.random() * 100
    return Array.from(crypto.getRandomValues(new Uint32Array(length)))
      .map(x => CHARs[x % CHARs.length])
      .join('')
  },

  arrayBufferToFileDownload (fileName, arrayBuffer) {
    let blob = new Blob([arrayBuffer], { type: 'octet/stream' })
    let link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = fileName
    link.click()
  },

  arrayBufferToBase64 (buffer) {
    let binary = ''
    let bytes = new Uint8Array(buffer)
    let len = bytes.byteLength
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i])
    }
    return window.btoa(binary)
  },

  base64ToArrayBuffer (base64) {
    // eslint-disable-next-line camelcase
    let binary_string = window.atob(base64)
    let len = binary_string.length
    let bytes = new Uint8Array(len)
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i)
    }
    return bytes
  }

  /* testing, not used */
  // async readAllFromReadableStream( readableStream ){
  // let result = [];
  // let reader = readableStream.getReader();

  // for( let i=0; i<99; i++ ){
  // const {value, done} = await reader.read();
  // if( done ){
  // return result;
  // }else{
  // // console.log('chunk:', i, value);
  // result.push( ...value );
  // }
  // }

  // }
}

CryptoUtil.PGPTool = {
  openpgp,

  async genKeyPair (passphrase) {
    let keypair = await openpgp.generateKey({
      userIDs: [{ name: '', email: '' }],
      // curve: 'curve25519', // default
      // format: 'armored',  // default
      passphrase
    })

    return keypair
  },

  async encryptArrayBufferWithPassword (arrayBuffer, passwords) {
    let openpgp = this.openpgp
    const message = await openpgp.createMessage({
      binary: arrayBuffer
    })
    const encrypted = await openpgp.encrypt({
      message,
      passwords,
      format: 'binary'
    })
    return encrypted
  },
  async decryptArrayBufferWithPassword (encryptedArrayBuffer, passwords) {
    let openpgp = this.openpgp
    const message = await openpgp.readMessage({
      binaryMessage: encryptedArrayBuffer
    })
    const decrypted = await openpgp.decrypt({
      message,
      passwords,
      format: 'binary'
    })
    return decrypted.data
  },

  async encryptText (text, publicKeyArmored) {
    let publicKey = await openpgp.readKey({
      armoredKey: publicKeyArmored
    })
    const message = await openpgp.createMessage({ text })
    const encrypted = await openpgp.encrypt({
      message,
      encryptionKeys: publicKey
    })
    return encrypted
  },
  decryptPrivateKey (encryptedPrivateKeyArmored, passphrase) {
    return openpgp.readPrivateKey({
      armoredKey: encryptedPrivateKeyArmored
    }).then(encryptedPrivateKey => {
      return openpgp.decryptKey({
        privateKey: encryptedPrivateKey,
        passphrase
      })
    })
  },

  async decryptText (encryptedText, encryptedPrivateKeyArmored, passphrase) {
    let privateKey = await this.decryptPrivateKey(encryptedPrivateKeyArmored, passphrase)
    return this.decryptText2(encryptedText, privateKey)
  },

  async decryptText2 (encryptedText, privateKey) {
    const message = await openpgp.readMessage({
      armoredMessage: encryptedText
    })
    const decrypted = await openpgp.decrypt({
      message,
      decryptionKeys: privateKey
    })
    return decrypted.data
  },

  async decryptArrayBuffer (arrayBuffer, privateKeyArmored, passphrase) {
    let privateKey = await openpgp.readPrivateKey(
      { armoredKey: privateKeyArmored }
    )
    // console.log( privateKey, privateKey.isDecrypted() );
    privateKey = await openpgp.decryptKey({
      privateKey,
      passphrase
    })
    // console.log( privateKey, privateKey.isDecrypted() );
    const message = await openpgp.readMessage({ binaryMessage: arrayBuffer })
    const decrypted = await openpgp.decrypt({
      message,
      decryptionKeys: privateKey,
      format: 'binary'
    })

    console.log(decrypted)

    return { arrayBuffer: decrypted.data }
  }

}

export default CryptoUtil
